import { faClock, faDollarSign, faUser, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAllRecipes } from './api';
import Heading1 from './headings/Heading1';

function Quickies() {
  const [recipes, setRecipes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAllRecipes()
      .then((all) => {
        console.log('Quickies: Total recipes fetched:', all?.length);
        
        // Filter for budget-friendly recipes marked as such
        const quickies = (all || []).filter((recipe) => {
          console.log('Recipe:', recipe.title, 'budgetFriendly:', recipe.budgetFriendly);
          // Must be marked as budget-friendly
          return recipe.budgetFriendly === true;
        });

        console.log('Quickies: Filtered recipes:', quickies.length);

        // Sort by prep time (quickest first)
        const sorted = quickies.sort((a, b) => {
          const timeA = parseInt(a.cookingMinutes || a.prepTime || 999);
          const timeB = parseInt(b.cookingMinutes || b.prepTime || 999);
          return timeA - timeB;
        });

        setRecipes(sorted.slice(0, 6)); // Show top 6
      })
      .catch((err) => console.error('Quickies error:', err));
  }, []);

  // Always render the section, show message if no recipes
  const handleClick = (id) => navigate(`/recipe/${id}`);

  return (
    <div className="max-w-7xl mx-auto px-6 py-12 space-y-6">
      <div className="text-left space-y-2">
        <div className="flex items-center gap-3">
          <Heading1 title="Quickies" />
          <span className="inline-flex items-center gap-1.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white px-3 py-1 rounded-full text-sm font-semibold shadow-md">
            <FontAwesomeIcon icon={faDollarSign} className="text-xs" />
            Budget-Friendly
          </span>
        </div>
        <p className="text-gray-600">Student-friendly meals • Under €15 per person • 1-2 portions • Quick to make (under 45 min)</p>
      </div>

      {recipes.length === 0 ? (
        <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8 text-center">
          <p className="text-gray-600">No budget-friendly recipes found. Check back soon!</p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {recipes.map((recipe) => (
              <div
                key={recipe.id}
                onClick={() => handleClick(recipe.id)}
                className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-green-200"
              >
                {/* Image Section */}
                <div className="relative h-48 overflow-hidden bg-gradient-to-br from-green-50 to-emerald-50">
                  <img
                    src={recipe.imageURL}
                    alt={recipe.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition duration-300"
                  />
                  <div className="absolute top-3 right-3 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg flex items-center gap-1">
                    <FontAwesomeIcon icon={faUser} className="text-xs" />
                    {recipe.portionSize || 1}
                  </div>
                </div>

                {/* Content Section */}
                <div className="p-4 space-y-3">
                  <h3 className="font-bold text-lg text-gray-900 group-hover:text-green-600 transition line-clamp-2">
                    {recipe.title}
                  </h3>

                  {/* Quick Stats */}
                  <div className="flex flex-wrap gap-2">
                    {recipe.cookingMinutes && (
                      <div className="flex items-center gap-1.5 text-xs bg-green-50 text-green-700 px-2.5 py-1.5 rounded-lg font-semibold">
                        <FontAwesomeIcon icon={faClock} />
                        {recipe.cookingMinutes} min
                      </div>
                    )}
                    {recipe.calories && (
                      <div className="flex items-center gap-1.5 text-xs bg-emerald-50 text-emerald-700 px-2.5 py-1.5 rounded-lg font-semibold">
                        
                        {recipe.calories} kcal
                      </div>
                    )}
                    {recipe.difficulty && (
                      <div className="flex items-center gap-1.5 text-xs bg-blue-50 text-blue-700 px-2.5 py-1.5 rounded-lg font-semibold">
                        <FontAwesomeIcon icon={faUtensils} />
                        {recipe.difficulty}
                      </div>
                    )}
                  </div>

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2 pt-2 border-t border-gray-100">
                    {recipe.vegan && (
                      <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full font-medium">
                        Vegan
                      </span>
                    )}
                    {recipe.highProtein && (
                      <span className="text-xs bg-purple-100 text-purple-800 px-2 py-0.5 rounded-full font-medium">
                        High Protein
                      </span>
                    )}
                    <span className="text-xs bg-orange-100 text-orange-800 px-2 py-0.5 rounded-full font-medium">
                      Student-Friendly
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* View All Button */}
          <div className="text-center pt-4">
            <button
              onClick={() => navigate('/budget-friendly')}
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-full font-semibold hover:from-green-600 hover:to-emerald-700 transition shadow-md hover:shadow-lg"
            >
              View All Budget Recipes
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default Quickies;
